import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, vShow as _vShow, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { class: "flex flex-col" }
const _hoisted_2 = {
  key: 0,
  class: "border-gray-lp-1400 border rounded-xl p-4"
}
const _hoisted_3 = { class: "p-field-checkbox flex flex-row items-center mt-3 ml-2 mb-2" }
const _hoisted_4 = {
  class: "ml-2.5 text-gray-lp-300 text-16px font-bold",
  for: "insurance"
}
const _hoisted_5 = { class: "text-12px font-normal font-montserrat text-gray-lp-600" }
const _hoisted_6 = {
  class: "mt-6",
  style: {"width":"100.6%"}
}
const _hoisted_7 = { class: "w-full" }
const _hoisted_8 = { class: "grid grid-cols-2 gap-x-4" }
const _hoisted_9 = { class: "border-gray-lp-1400 border rounded-xl flex flex-col p-4 gap-y-4" }
const _hoisted_10 = { class: "border-gray-lp-1400 border rounded-xl p-4" }
const _hoisted_11 = { class: "p-field-checkbox flex flex-row items-center mt-3 ml-2 mb-2" }
const _hoisted_12 = {
  class: "ml-2.5 text-gray-lp-300 text-16px font-bold",
  for: "insurance"
}
const _hoisted_13 = { class: "text-12px font-normal font-montserrat text-gray-lp-600" }
const _hoisted_14 = {
  class: "mt-6",
  style: {"width":"100.6%"}
}
const _hoisted_15 = { class: "w-full" }
const _hoisted_16 = { class: "mt-4 w-full" }
const _hoisted_17 = { class: "ml-2 text-12px text-gray-lp-300 font-semibold" }
const _hoisted_18 = { class: "text-12px text-gray-lp-600 font-normal" }
const _hoisted_19 = { class: "grid grid-cols-2 gap-x-4" }
const _hoisted_20 = { class: "border-gray-lp-1400 border rounded-xl flex flex-col p-4 gap-y-4" }
const _hoisted_21 = { class: "flex flex-col" }
const _hoisted_22 = { class: "text-20px text-gray-lp-300 font-bold" }
const _hoisted_23 = { class: "text-14px text-gray-lp-600 font-normal" }
const _hoisted_24 = { class: "rounded bg-gray-lp-1000 p-4 flex justify-between" }
const _hoisted_25 = { class: "flex flex-row gap-x-2" }
const _hoisted_26 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M14.6666 5.74609H9.33325V8.74609H14.6666V5.74609Z",
    fill: "#21A366"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M14.6667 8.74609H4V14.0794C4 14.4478 4.29833 14.7461 4.66667 14.7461H14C14.3683 14.7461 14.6667 14.4478 14.6667 14.0794V8.74609Z",
    fill: "#185C37"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M14.6666 8.74609H9.33325V11.7461H14.6666V8.74609Z",
    fill: "#107C42"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M9.33333 5.74609H4V8.74609H9.33333V5.74609Z",
    fill: "#3FA071"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M13.9999 2.74609H9.33325V5.74609H14.6666V3.41276C14.6666 3.04443 14.3683 2.74609 13.9999 2.74609Z",
    fill: "#33C481"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M4.66667 2.74609H9.33333V5.74609H4V3.41276C4 3.04443 4.29833 2.74609 4.66667 2.74609Z",
    fill: "#21A366"
  }),
  /*#__PURE__*/_createVNode("path", {
    opacity: "0.05",
    d: "M7.43967 5.07812H4V13.0781H7.43967C8.11733 13.0781 8.66667 12.5288 8.66667 11.8511V6.30512C8.66667 5.62746 8.11733 5.07812 7.43967 5.07812Z",
    fill: "black"
  }),
  /*#__PURE__*/_createVNode("path", {
    opacity: "0.07",
    d: "M7.40433 12.7471H4V5.19141H7.40433C7.979 5.19141 8.44467 5.65707 8.44467 6.23174V11.7067C8.44433 12.2814 7.97867 12.7471 7.40433 12.7471Z",
    fill: "black"
  }),
  /*#__PURE__*/_createVNode("path", {
    opacity: "0.09",
    d: "M7.36867 12.4118H4V5.30078H7.36867C7.84 5.30078 8.222 5.68278 8.222 6.15411V11.5584C8.22233 12.0298 7.84 12.4118 7.36867 12.4118Z",
    fill: "black"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M7.33301 12.0807H1.99967C1.63134 12.0807 1.33301 11.7824 1.33301 11.4141V6.08073C1.33301 5.7124 1.63134 5.41406 1.99967 5.41406H7.33301C7.70134 5.41406 7.99967 5.7124 7.99967 6.08073V11.4141C7.99967 11.7824 7.70134 12.0807 7.33301 12.0807Z",
    fill: "url(#paint0_linear_6530_41742)"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M3.26896 7.07812H4.06429L4.70963 8.32946L5.39163 7.07812H6.13463L5.11096 8.74479L6.15796 10.4115H5.37429L4.67096 9.10146L3.97063 10.4115H3.17529L4.23963 8.73879L3.26896 7.07812Z",
    fill: "white"
  }),
  /*#__PURE__*/_createVNode("defs", null, [
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "paint0_linear_6530_41742",
      x1: "1.57467",
      y1: "5.65573",
      x2: "7.68467",
      y2: "11.7657",
      gradientUnits: "userSpaceOnUse"
    }, [
      /*#__PURE__*/_createVNode("stop", { "stop-color": "#18884F" }),
      /*#__PURE__*/_createVNode("stop", {
        offset: "1",
        "stop-color": "#0B6731"
      })
    ])
  ])
], -1)
const _hoisted_27 = { class: "text-12px text-gray-lp-300 font-semibold" }
const _hoisted_28 = /*#__PURE__*/_createVNode("svg", {
  width: "68",
  height: "25",
  viewBox: "0 0 68 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("rect", {
    x: "0.5",
    y: "1.24609",
    width: "67",
    height: "23",
    rx: "5.5",
    stroke: "#A7A8AA"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M9.23375 16.7461V9.74609H12.2938C13.0538 9.74609 13.7204 9.89276 14.2938 10.1861C14.8671 10.4794 15.3138 10.8861 15.6338 11.4061C15.9538 11.9261 16.1138 12.5394 16.1138 13.2461C16.1138 13.9461 15.9538 14.5594 15.6338 15.0861C15.3138 15.6061 14.8671 16.0128 14.2938 16.3061C13.7204 16.5994 13.0538 16.7461 12.2938 16.7461H9.23375ZM10.5338 15.6461H12.2338C12.7604 15.6461 13.2138 15.5461 13.5938 15.3461C13.9804 15.1461 14.2771 14.8661 14.4838 14.5061C14.6971 14.1461 14.8038 13.7261 14.8038 13.2461C14.8038 12.7594 14.6971 12.3394 14.4838 11.9861C14.2771 11.6261 13.9804 11.3461 13.5938 11.1461C13.2138 10.9461 12.7604 10.8461 12.2338 10.8461H10.5338V15.6461ZM19.5755 16.8161C19.0288 16.8161 18.5421 16.6994 18.1155 16.4661C17.6888 16.2261 17.3521 15.8994 17.1055 15.4861C16.8588 15.0728 16.7355 14.6028 16.7355 14.0761C16.7355 13.5428 16.8588 13.0728 17.1055 12.6661C17.3521 12.2528 17.6888 11.9294 18.1155 11.6961C18.5421 11.4628 19.0288 11.3461 19.5755 11.3461C20.1288 11.3461 20.6188 11.4628 21.0455 11.6961C21.4788 11.9294 21.8155 12.2494 22.0555 12.6561C22.3021 13.0628 22.4255 13.5361 22.4255 14.0761C22.4255 14.6028 22.3021 15.0728 22.0555 15.4861C21.8155 15.8994 21.4788 16.2261 21.0455 16.4661C20.6188 16.6994 20.1288 16.8161 19.5755 16.8161ZM19.5755 15.7461C19.8821 15.7461 20.1555 15.6794 20.3955 15.5461C20.6355 15.4128 20.8221 15.2194 20.9555 14.9661C21.0955 14.7128 21.1655 14.4161 21.1655 14.0761C21.1655 13.7294 21.0955 13.4328 20.9555 13.1861C20.8221 12.9328 20.6355 12.7394 20.3955 12.6061C20.1555 12.4728 19.8855 12.4061 19.5855 12.4061C19.2788 12.4061 19.0055 12.4728 18.7655 12.6061C18.5321 12.7394 18.3455 12.9328 18.2055 13.1861C18.0655 13.4328 17.9955 13.7294 17.9955 14.0761C17.9955 14.4161 18.0655 14.7128 18.2055 14.9661C18.3455 15.2194 18.5321 15.4128 18.7655 15.5461C19.0055 15.6794 19.2755 15.7461 19.5755 15.7461ZM24.4543 16.7461L22.4943 11.4061H23.6743L25.3543 16.1161H24.7943L26.5543 11.4061H27.6043L29.3143 16.1161H28.7643L30.4943 11.4061H31.6043L29.6343 16.7461H28.4343L26.8743 12.5761H27.2443L25.6543 16.7461H24.4543ZM35.2938 11.3461C35.7204 11.3461 36.1004 11.4294 36.4338 11.5961C36.7738 11.7628 37.0404 12.0194 37.2338 12.3661C37.4271 12.7061 37.5238 13.1461 37.5238 13.6861V16.7461H36.2738V13.8461C36.2738 13.3728 36.1604 13.0194 35.9338 12.7861C35.7138 12.5528 35.4038 12.4361 35.0038 12.4361C34.7104 12.4361 34.4504 12.4961 34.2238 12.6161C33.9971 12.7361 33.8204 12.9161 33.6938 13.1561C33.5738 13.3894 33.5138 13.6861 33.5138 14.0461V16.7461H32.2638V11.4061H33.4538V12.8461L33.2438 12.4061C33.4304 12.0661 33.7004 11.8061 34.0538 11.6261C34.4138 11.4394 34.8271 11.3461 35.2938 11.3461ZM38.9095 16.7461V9.32609H40.1595V16.7461H38.9095ZM44.0001 16.8161C43.4534 16.8161 42.9667 16.6994 42.5401 16.4661C42.1134 16.2261 41.7767 15.8994 41.5301 15.4861C41.2834 15.0728 41.1601 14.6028 41.1601 14.0761C41.1601 13.5428 41.2834 13.0728 41.5301 12.6661C41.7767 12.2528 42.1134 11.9294 42.5401 11.6961C42.9667 11.4628 43.4534 11.3461 44.0001 11.3461C44.5534 11.3461 45.0434 11.4628 45.4701 11.6961C45.9034 11.9294 46.2401 12.2494 46.4801 12.6561C46.7267 13.0628 46.8501 13.5361 46.8501 14.0761C46.8501 14.6028 46.7267 15.0728 46.4801 15.4861C46.2401 15.8994 45.9034 16.2261 45.4701 16.4661C45.0434 16.6994 44.5534 16.8161 44.0001 16.8161ZM44.0001 15.7461C44.3067 15.7461 44.5801 15.6794 44.8201 15.5461C45.0601 15.4128 45.2467 15.2194 45.3801 14.9661C45.5201 14.7128 45.5901 14.4161 45.5901 14.0761C45.5901 13.7294 45.5201 13.4328 45.3801 13.1861C45.2467 12.9328 45.0601 12.7394 44.8201 12.6061C44.5801 12.4728 44.3101 12.4061 44.0101 12.4061C43.7034 12.4061 43.4301 12.4728 43.1901 12.6061C42.9567 12.7394 42.7701 12.9328 42.6301 13.1861C42.4901 13.4328 42.4201 13.7294 42.4201 14.0761C42.4201 14.4161 42.4901 14.7128 42.6301 14.9661C42.7701 15.2194 42.9567 15.4128 43.1901 15.5461C43.4301 15.6794 43.7001 15.7461 44.0001 15.7461ZM51.067 16.7461V15.6661L50.997 15.4361V13.5461C50.997 13.1794 50.887 12.8961 50.667 12.6961C50.447 12.4894 50.1137 12.3861 49.667 12.3861C49.367 12.3861 49.0704 12.4328 48.777 12.5261C48.4904 12.6194 48.247 12.7494 48.047 12.9161L47.557 12.0061C47.8437 11.7861 48.1837 11.6228 48.577 11.5161C48.977 11.4028 49.3904 11.3461 49.817 11.3461C50.5904 11.3461 51.187 11.5328 51.607 11.9061C52.0337 12.2728 52.247 12.8428 52.247 13.6161V16.7461H51.067ZM49.387 16.8161C48.987 16.8161 48.637 16.7494 48.337 16.6161C48.037 16.4761 47.8037 16.2861 47.637 16.0461C47.477 15.7994 47.397 15.5228 47.397 15.2161C47.397 14.9161 47.467 14.6461 47.607 14.4061C47.7537 14.1661 47.9904 13.9761 48.317 13.8361C48.6437 13.6961 49.077 13.6261 49.617 13.6261H51.167V14.4561H49.707C49.2804 14.4561 48.9937 14.5261 48.847 14.6661C48.7004 14.7994 48.627 14.9661 48.627 15.1661C48.627 15.3928 48.717 15.5728 48.897 15.7061C49.077 15.8394 49.327 15.9061 49.647 15.9061C49.9537 15.9061 50.227 15.8361 50.467 15.6961C50.7137 15.5561 50.8904 15.3494 50.997 15.0761L51.207 15.8261C51.087 16.1394 50.8704 16.3828 50.557 16.5561C50.2504 16.7294 49.8604 16.8161 49.387 16.8161ZM55.921 16.8161C55.4077 16.8161 54.9443 16.7028 54.531 16.4761C54.1243 16.2428 53.8043 15.9228 53.571 15.5161C53.3377 15.1094 53.221 14.6294 53.221 14.0761C53.221 13.5228 53.3377 13.0428 53.571 12.6361C53.8043 12.2294 54.1243 11.9128 54.531 11.6861C54.9443 11.4594 55.4077 11.3461 55.921 11.3461C56.3677 11.3461 56.7677 11.4461 57.121 11.6461C57.4743 11.8394 57.7543 12.1361 57.961 12.5361C58.1677 12.9361 58.271 13.4494 58.271 14.0761C58.271 14.6961 58.171 15.2094 57.971 15.6161C57.771 16.0161 57.4943 16.3161 57.141 16.5161C56.7877 16.7161 56.381 16.8161 55.921 16.8161ZM56.071 15.7461C56.371 15.7461 56.6377 15.6794 56.871 15.5461C57.111 15.4128 57.301 15.2194 57.441 14.9661C57.5877 14.7128 57.661 14.4161 57.661 14.0761C57.661 13.7294 57.5877 13.4328 57.441 13.1861C57.301 12.9328 57.111 12.7394 56.871 12.6061C56.6377 12.4728 56.371 12.4061 56.071 12.4061C55.771 12.4061 55.501 12.4728 55.261 12.6061C55.0277 12.7394 54.8377 12.9328 54.691 13.1861C54.551 13.4328 54.481 13.7294 54.481 14.0761C54.481 14.4161 54.551 14.7128 54.691 14.9661C54.8377 15.2194 55.0277 15.4128 55.261 15.5461C55.501 15.6794 55.771 15.7461 56.071 15.7461ZM57.691 16.7461V15.4861L57.741 14.0661L57.641 12.6461V9.32609H58.881V16.7461H57.691Z",
    fill: "#4D4D4D"
  })
], -1)
const _hoisted_29 = { class: "ml-2 text-12px text-gray-lp-300 font-bold" }
const _hoisted_30 = { class: "text-12px text-gray-lp-600 font-normal" }
const _hoisted_31 = { class: "border-gray-lp-1400 border rounded-xl p-4" }
const _hoisted_32 = { class: "p-field-checkbox flex flex-row items-center mt-3 ml-2 mb-2" }
const _hoisted_33 = {
  class: "ml-2.5 text-gray-lp-300 text-16px font-bold",
  for: "insurance"
}
const _hoisted_34 = { class: "text-12px font-normal font-montserrat text-gray-lp-600" }
const _hoisted_35 = {
  class: "mt-6",
  style: {"width":"100.6%"}
}
const _hoisted_36 = { class: "w-full" }
const _hoisted_37 = /*#__PURE__*/_createVNode("hr", { class: "my-4" }, null, -1)
const _hoisted_38 = { class: "grid grid-cols-2 gap-x-4 mb-5" }
const _hoisted_39 = {
  key: 0,
  class: "grid grid-cols-2 gap-x-4 mt-2"
}
const _hoisted_40 = { class: "grid grid-cols-2 gap-x-4 mt-5" }
const _hoisted_41 = { class: "border-gray-lp-1400 border rounded-xl flex flex-col p-4 gap-y-4" }
const _hoisted_42 = { class: "flex flex-col" }
const _hoisted_43 = { class: "text-20px text-gray-lp-300 font-bold" }
const _hoisted_44 = { class: "text-14px text-gray-lp-600 font-normal" }
const _hoisted_45 = { class: "rounded bg-gray-lp-1000 p-4 flex justify-between" }
const _hoisted_46 = { class: "flex flex-row gap-x-2" }
const _hoisted_47 = /*#__PURE__*/_createVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "17",
  viewBox: "0 0 16 17",
  fill: "none"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M14.6666 5.74609H9.33325V8.74609H14.6666V5.74609Z",
    fill: "#21A366"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M14.6667 8.74609H4V14.0794C4 14.4478 4.29833 14.7461 4.66667 14.7461H14C14.3683 14.7461 14.6667 14.4478 14.6667 14.0794V8.74609Z",
    fill: "#185C37"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M14.6666 8.74609H9.33325V11.7461H14.6666V8.74609Z",
    fill: "#107C42"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M9.33333 5.74609H4V8.74609H9.33333V5.74609Z",
    fill: "#3FA071"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M13.9999 2.74609H9.33325V5.74609H14.6666V3.41276C14.6666 3.04443 14.3683 2.74609 13.9999 2.74609Z",
    fill: "#33C481"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M4.66667 2.74609H9.33333V5.74609H4V3.41276C4 3.04443 4.29833 2.74609 4.66667 2.74609Z",
    fill: "#21A366"
  }),
  /*#__PURE__*/_createVNode("path", {
    opacity: "0.05",
    d: "M7.43967 5.07812H4V13.0781H7.43967C8.11733 13.0781 8.66667 12.5288 8.66667 11.8511V6.30512C8.66667 5.62746 8.11733 5.07812 7.43967 5.07812Z",
    fill: "black"
  }),
  /*#__PURE__*/_createVNode("path", {
    opacity: "0.07",
    d: "M7.40433 12.7471H4V5.19141H7.40433C7.979 5.19141 8.44467 5.65707 8.44467 6.23174V11.7067C8.44433 12.2814 7.97867 12.7471 7.40433 12.7471Z",
    fill: "black"
  }),
  /*#__PURE__*/_createVNode("path", {
    opacity: "0.09",
    d: "M7.36867 12.4118H4V5.30078H7.36867C7.84 5.30078 8.222 5.68278 8.222 6.15411V11.5584C8.22233 12.0298 7.84 12.4118 7.36867 12.4118Z",
    fill: "black"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M7.33301 12.0807H1.99967C1.63134 12.0807 1.33301 11.7824 1.33301 11.4141V6.08073C1.33301 5.7124 1.63134 5.41406 1.99967 5.41406H7.33301C7.70134 5.41406 7.99967 5.7124 7.99967 6.08073V11.4141C7.99967 11.7824 7.70134 12.0807 7.33301 12.0807Z",
    fill: "url(#paint0_linear_6530_41742)"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M3.26896 7.07812H4.06429L4.70963 8.32946L5.39163 7.07812H6.13463L5.11096 8.74479L6.15796 10.4115H5.37429L4.67096 9.10146L3.97063 10.4115H3.17529L4.23963 8.73879L3.26896 7.07812Z",
    fill: "white"
  }),
  /*#__PURE__*/_createVNode("defs", null, [
    /*#__PURE__*/_createVNode("linearGradient", {
      id: "paint0_linear_6530_41742",
      x1: "1.57467",
      y1: "5.65573",
      x2: "7.68467",
      y2: "11.7657",
      gradientUnits: "userSpaceOnUse"
    }, [
      /*#__PURE__*/_createVNode("stop", { "stop-color": "#18884F" }),
      /*#__PURE__*/_createVNode("stop", {
        offset: "1",
        "stop-color": "#0B6731"
      })
    ])
  ])
], -1)
const _hoisted_48 = { class: "text-12px text-gray-lp-300 font-semibold" }
const _hoisted_49 = /*#__PURE__*/_createVNode("svg", {
  width: "68",
  height: "25",
  viewBox: "0 0 68 25",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createVNode("rect", {
    x: "0.5",
    y: "1.24609",
    width: "67",
    height: "23",
    rx: "5.5",
    stroke: "#A7A8AA"
  }),
  /*#__PURE__*/_createVNode("path", {
    d: "M9.23375 16.7461V9.74609H12.2938C13.0538 9.74609 13.7204 9.89276 14.2938 10.1861C14.8671 10.4794 15.3138 10.8861 15.6338 11.4061C15.9538 11.9261 16.1138 12.5394 16.1138 13.2461C16.1138 13.9461 15.9538 14.5594 15.6338 15.0861C15.3138 15.6061 14.8671 16.0128 14.2938 16.3061C13.7204 16.5994 13.0538 16.7461 12.2938 16.7461H9.23375ZM10.5338 15.6461H12.2338C12.7604 15.6461 13.2138 15.5461 13.5938 15.3461C13.9804 15.1461 14.2771 14.8661 14.4838 14.5061C14.6971 14.1461 14.8038 13.7261 14.8038 13.2461C14.8038 12.7594 14.6971 12.3394 14.4838 11.9861C14.2771 11.6261 13.9804 11.3461 13.5938 11.1461C13.2138 10.9461 12.7604 10.8461 12.2338 10.8461H10.5338V15.6461ZM19.5755 16.8161C19.0288 16.8161 18.5421 16.6994 18.1155 16.4661C17.6888 16.2261 17.3521 15.8994 17.1055 15.4861C16.8588 15.0728 16.7355 14.6028 16.7355 14.0761C16.7355 13.5428 16.8588 13.0728 17.1055 12.6661C17.3521 12.2528 17.6888 11.9294 18.1155 11.6961C18.5421 11.4628 19.0288 11.3461 19.5755 11.3461C20.1288 11.3461 20.6188 11.4628 21.0455 11.6961C21.4788 11.9294 21.8155 12.2494 22.0555 12.6561C22.3021 13.0628 22.4255 13.5361 22.4255 14.0761C22.4255 14.6028 22.3021 15.0728 22.0555 15.4861C21.8155 15.8994 21.4788 16.2261 21.0455 16.4661C20.6188 16.6994 20.1288 16.8161 19.5755 16.8161ZM19.5755 15.7461C19.8821 15.7461 20.1555 15.6794 20.3955 15.5461C20.6355 15.4128 20.8221 15.2194 20.9555 14.9661C21.0955 14.7128 21.1655 14.4161 21.1655 14.0761C21.1655 13.7294 21.0955 13.4328 20.9555 13.1861C20.8221 12.9328 20.6355 12.7394 20.3955 12.6061C20.1555 12.4728 19.8855 12.4061 19.5855 12.4061C19.2788 12.4061 19.0055 12.4728 18.7655 12.6061C18.5321 12.7394 18.3455 12.9328 18.2055 13.1861C18.0655 13.4328 17.9955 13.7294 17.9955 14.0761C17.9955 14.4161 18.0655 14.7128 18.2055 14.9661C18.3455 15.2194 18.5321 15.4128 18.7655 15.5461C19.0055 15.6794 19.2755 15.7461 19.5755 15.7461ZM24.4543 16.7461L22.4943 11.4061H23.6743L25.3543 16.1161H24.7943L26.5543 11.4061H27.6043L29.3143 16.1161H28.7643L30.4943 11.4061H31.6043L29.6343 16.7461H28.4343L26.8743 12.5761H27.2443L25.6543 16.7461H24.4543ZM35.2938 11.3461C35.7204 11.3461 36.1004 11.4294 36.4338 11.5961C36.7738 11.7628 37.0404 12.0194 37.2338 12.3661C37.4271 12.7061 37.5238 13.1461 37.5238 13.6861V16.7461H36.2738V13.8461C36.2738 13.3728 36.1604 13.0194 35.9338 12.7861C35.7138 12.5528 35.4038 12.4361 35.0038 12.4361C34.7104 12.4361 34.4504 12.4961 34.2238 12.6161C33.9971 12.7361 33.8204 12.9161 33.6938 13.1561C33.5738 13.3894 33.5138 13.6861 33.5138 14.0461V16.7461H32.2638V11.4061H33.4538V12.8461L33.2438 12.4061C33.4304 12.0661 33.7004 11.8061 34.0538 11.6261C34.4138 11.4394 34.8271 11.3461 35.2938 11.3461ZM38.9095 16.7461V9.32609H40.1595V16.7461H38.9095ZM44.0001 16.8161C43.4534 16.8161 42.9667 16.6994 42.5401 16.4661C42.1134 16.2261 41.7767 15.8994 41.5301 15.4861C41.2834 15.0728 41.1601 14.6028 41.1601 14.0761C41.1601 13.5428 41.2834 13.0728 41.5301 12.6661C41.7767 12.2528 42.1134 11.9294 42.5401 11.6961C42.9667 11.4628 43.4534 11.3461 44.0001 11.3461C44.5534 11.3461 45.0434 11.4628 45.4701 11.6961C45.9034 11.9294 46.2401 12.2494 46.4801 12.6561C46.7267 13.0628 46.8501 13.5361 46.8501 14.0761C46.8501 14.6028 46.7267 15.0728 46.4801 15.4861C46.2401 15.8994 45.9034 16.2261 45.4701 16.4661C45.0434 16.6994 44.5534 16.8161 44.0001 16.8161ZM44.0001 15.7461C44.3067 15.7461 44.5801 15.6794 44.8201 15.5461C45.0601 15.4128 45.2467 15.2194 45.3801 14.9661C45.5201 14.7128 45.5901 14.4161 45.5901 14.0761C45.5901 13.7294 45.5201 13.4328 45.3801 13.1861C45.2467 12.9328 45.0601 12.7394 44.8201 12.6061C44.5801 12.4728 44.3101 12.4061 44.0101 12.4061C43.7034 12.4061 43.4301 12.4728 43.1901 12.6061C42.9567 12.7394 42.7701 12.9328 42.6301 13.1861C42.4901 13.4328 42.4201 13.7294 42.4201 14.0761C42.4201 14.4161 42.4901 14.7128 42.6301 14.9661C42.7701 15.2194 42.9567 15.4128 43.1901 15.5461C43.4301 15.6794 43.7001 15.7461 44.0001 15.7461ZM51.067 16.7461V15.6661L50.997 15.4361V13.5461C50.997 13.1794 50.887 12.8961 50.667 12.6961C50.447 12.4894 50.1137 12.3861 49.667 12.3861C49.367 12.3861 49.0704 12.4328 48.777 12.5261C48.4904 12.6194 48.247 12.7494 48.047 12.9161L47.557 12.0061C47.8437 11.7861 48.1837 11.6228 48.577 11.5161C48.977 11.4028 49.3904 11.3461 49.817 11.3461C50.5904 11.3461 51.187 11.5328 51.607 11.9061C52.0337 12.2728 52.247 12.8428 52.247 13.6161V16.7461H51.067ZM49.387 16.8161C48.987 16.8161 48.637 16.7494 48.337 16.6161C48.037 16.4761 47.8037 16.2861 47.637 16.0461C47.477 15.7994 47.397 15.5228 47.397 15.2161C47.397 14.9161 47.467 14.6461 47.607 14.4061C47.7537 14.1661 47.9904 13.9761 48.317 13.8361C48.6437 13.6961 49.077 13.6261 49.617 13.6261H51.167V14.4561H49.707C49.2804 14.4561 48.9937 14.5261 48.847 14.6661C48.7004 14.7994 48.627 14.9661 48.627 15.1661C48.627 15.3928 48.717 15.5728 48.897 15.7061C49.077 15.8394 49.327 15.9061 49.647 15.9061C49.9537 15.9061 50.227 15.8361 50.467 15.6961C50.7137 15.5561 50.8904 15.3494 50.997 15.0761L51.207 15.8261C51.087 16.1394 50.8704 16.3828 50.557 16.5561C50.2504 16.7294 49.8604 16.8161 49.387 16.8161ZM55.921 16.8161C55.4077 16.8161 54.9443 16.7028 54.531 16.4761C54.1243 16.2428 53.8043 15.9228 53.571 15.5161C53.3377 15.1094 53.221 14.6294 53.221 14.0761C53.221 13.5228 53.3377 13.0428 53.571 12.6361C53.8043 12.2294 54.1243 11.9128 54.531 11.6861C54.9443 11.4594 55.4077 11.3461 55.921 11.3461C56.3677 11.3461 56.7677 11.4461 57.121 11.6461C57.4743 11.8394 57.7543 12.1361 57.961 12.5361C58.1677 12.9361 58.271 13.4494 58.271 14.0761C58.271 14.6961 58.171 15.2094 57.971 15.6161C57.771 16.0161 57.4943 16.3161 57.141 16.5161C56.7877 16.7161 56.381 16.8161 55.921 16.8161ZM56.071 15.7461C56.371 15.7461 56.6377 15.6794 56.871 15.5461C57.111 15.4128 57.301 15.2194 57.441 14.9661C57.5877 14.7128 57.661 14.4161 57.661 14.0761C57.661 13.7294 57.5877 13.4328 57.441 13.1861C57.301 12.9328 57.111 12.7394 56.871 12.6061C56.6377 12.4728 56.371 12.4061 56.071 12.4061C55.771 12.4061 55.501 12.4728 55.261 12.6061C55.0277 12.7394 54.8377 12.9328 54.691 13.1861C54.551 13.4328 54.481 13.7294 54.481 14.0761C54.481 14.4161 54.551 14.7128 54.691 14.9661C54.8377 15.2194 55.0277 15.4128 55.261 15.5461C55.501 15.6794 55.771 15.7461 56.071 15.7461ZM57.691 16.7461V15.4861L57.741 14.0661L57.641 12.6461V9.32609H58.881V16.7461H57.691Z",
    fill: "#4D4D4D"
  })
], -1)
const _hoisted_50 = { class: "border-gray-lp-1400 border rounded-xl p-4" }
const _hoisted_51 = { class: "p-field-checkbox flex flex-row items-center mt-3 ml-2 mb-2" }
const _hoisted_52 = {
  class: "ml-2.5 text-gray-lp-300 text-16px font-bold",
  for: "insurance"
}
const _hoisted_53 = { class: "text-12px font-normal font-montserrat text-gray-lp-600" }
const _hoisted_54 = {
  class: "mt-6",
  style: {"width":"100.6%"}
}
const _hoisted_55 = { class: "w-full" }
const _hoisted_56 = { class: "mt-4 w-full" }
const _hoisted_57 = { class: "ml-2 text-12px text-gray-lp-300 font-semibold" }
const _hoisted_58 = { class: "text-12px text-gray-lp-600 font-normal" }
const _hoisted_59 = {
  key: 0,
  class: "flex gap-x-8 w-4/5 mb-1"
}
const _hoisted_60 = { class: "flex gap-x-8 w-10/12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Select = _resolveComponent("Select")!
  const _component_lp_input = _resolveComponent("lp-input")!
  const _component_SelectSearch = _resolveComponent("SelectSearch")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_MultipleSelectSearch = _resolveComponent("MultipleSelectSearch")!
  const _component_ClientDiscountConfigToggle = _resolveComponent("ClientDiscountConfigToggle")!
  const _component_DiscountProduct = _resolveComponent("DiscountProduct")!
  const _component_ToggleV2 = _resolveComponent("ToggleV2")!
  const _component_UploadFile = _resolveComponent("UploadFile")!
  const _component_DateTimeInputField = _resolveComponent("DateTimeInputField")!
  const _component_DatePicker = _resolveComponent("DatePicker")!
  const _component_CardSelectorV2 = _resolveComponent("CardSelectorV2")!

  return (_openBlock(), _createBlock("div", null, [
    _createVNode(_component_CardSelectorV2, {
      modelValue: _ctx.modelValue,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.modelValue = $event)),
      options: _ctx.isEdit ? _ctx.customPriceOptionEdit : _ctx.customPriceOption,
      onOnResetForm: _ctx.onResetForm,
      onOnSelectOption: _ctx.onSelect
    }, {
      form: _withCtx(() => [
        _createVNode("div", _hoisted_1, [
          (_ctx.modelValue.isCustomRate === 'retail')
            ? (_openBlock(), _createBlock("div", _hoisted_2, [
                _createVNode("div", _hoisted_3, [
                  _createVNode(_component_Checkbox, {
                    id: "insurance",
                    modelValue: _ctx.modelValue.isInsurance,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.modelValue.isInsurance = $event)),
                    binary: true
                  }, null, 8, ["modelValue"]),
                  _createVNode("label", _hoisted_4, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.insurance')), 1)
                ]),
                _createVNode("p", _hoisted_5, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.insuranceHint')), 1),
                _createVNode("div", _hoisted_6, [
                  _createVNode(_component_Select, {
                    onOpenSelect: _ctx.onOpenSelectInsurance,
                    onCloseSelect: _ctx.onCloseSelectInsurance,
                    isOpenMenu: _ctx.isOpenSelectInsurance,
                    value: _ctx.modelValue.insurance,
                    onChooseSelect: _ctx.onSelectInsurance,
                    isDisabled: !_ctx.modelValue.isInsurance,
                    disabledBackground: !_ctx.modelValue.isInsurance,
                    dataSelect: _ctx.insurances,
                    class: "whitespace-no-wrap my-2 z-10"
                  }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "isDisabled", "disabledBackground", "dataSelect"])
                ]),
                _createVNode("div", _hoisted_7, [
                  (
                    _ctx.modelValue.isInsurance &&
                      (_ctx.modelValue.insurance === 'custom-rates' || _ctx.modelValue.insurance === 'custom')
                  )
                    ? (_openBlock(), _createBlock(_component_lp_input, {
                        key: 0,
                        modelValue: _ctx.modelValue.customRates,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.modelValue.customRates = $event)),
                        error: _ctx.error.customRates,
                        onChange: _ctx.validateCustomRates,
                        errorCaption: _ctx.errorCaptionCustomRates,
                        placeholder: _ctx.$t('clientManagement.priceTypeForm.customRatesPlaceholder'),
                        min: "2",
                        max: "99",
                        suffix: "%",
                        isErrorIconInput: false,
                        type: "number",
                        isFloatingPrefixNumber: ""
                      }, null, 8, ["modelValue", "error", "onChange", "errorCaption", "placeholder"]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          (_ctx.modelValue.isCustomRate === 'normal')
            ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                _createVNode("div", _hoisted_8, [
                  _createVNode("div", _hoisted_9, [
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('clientManagement.priceTypeForm.normalPriceVersion'),
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_SelectSearch, {
                          class: "mt-2",
                          onFilter: _ctx.fetchVersionRates,
                          isLoading: _ctx.loadingVersionRates,
                          options: _ctx.versionRates,
                          keyName: "rateVersionName",
                          keyValue: "rateVersionName",
                          placeholder: _ctx.$t('clientManagement.priceTypeForm.selectPriceVersion'),
                          modelValue: _ctx.modelValue.versionBasic,
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.modelValue.versionBasic = $event))
                        }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_DataWrapper, {
                      label: _ctx.$t('clientManagement.priceTypeForm.origin3lc'),
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_MultipleSelectSearch, {
                          "modal-title": _ctx.$t('clientManagement.priceTypeForm.selectedOrigin3lc'),
                          "option-name": "kota",
                          customDisplayAll: _ctx.$t('clientManagement.priceTypeForm.all3lc'),
                          onFocus: _ctx.fetchCity,
                          onFilter: _ctx.filterCity,
                          options: _ctx.cityOptions,
                          modelValue: _ctx.modelValue.originCities,
                          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.modelValue.originCities = $event)),
                          keyName: "name",
                          keyValue: "value",
                          placeholder: _ctx.$t('clientManagement.priceTypeForm.select3lcByClientNeed'),
                          isLoading: _ctx.isLoadingCity,
                          showReset: "",
                          onChange: ($event: any) => (
                      {
                      }
                    ),
                          class: "mt-2",
                          "able-to-delete-in-modal": ""
                        }, null, 8, ["modal-title", "customDisplayAll", "onFocus", "onFilter", "options", "modelValue", "placeholder", "isLoading"])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_ClientDiscountConfigToggle, {
                      modelValue: _ctx.modelValue.useClientDiscountConfig,
                      "onUpdate:modelValue": [
                        _cache[5] || (_cache[5] = ($event: any) => (_ctx.modelValue.useClientDiscountConfig = $event)),
                        _ctx.onUpdateClientDiscountConfigToggle
                      ]
                    }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                    (_ctx.modelValue.useClientDiscountConfig)
                      ? (_openBlock(), _createBlock(_component_DataWrapper, {
                          key: 0,
                          label: "Diskon",
                          class: "w-full"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_DiscountProduct, {
                              error: _ctx.error,
                              modelValue: _ctx.modelValue.discount,
                              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.modelValue.discount = $event))
                            }, null, 8, ["error", "modelValue"])
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true)
                  ]),
                  _createVNode("div", _hoisted_10, [
                    _createVNode("div", _hoisted_11, [
                      _createVNode(_component_Checkbox, {
                        id: "insurance",
                        modelValue: _ctx.modelValue.isInsurance,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.modelValue.isInsurance = $event)),
                        binary: true
                      }, null, 8, ["modelValue"]),
                      _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.insurance')), 1)
                    ]),
                    _createVNode("p", _hoisted_13, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.insuranceHint')), 1),
                    _createVNode("div", _hoisted_14, [
                      _createVNode(_component_Select, {
                        onOpenSelect: _ctx.onOpenSelectInsurance,
                        onCloseSelect: _ctx.onCloseSelectInsurance,
                        isOpenMenu: _ctx.isOpenSelectInsurance,
                        value: _ctx.modelValue.insurance,
                        onChooseSelect: _ctx.onSelectInsurance,
                        isDisabled: !_ctx.modelValue.isInsurance,
                        disabledBackground: !_ctx.modelValue.isInsurance,
                        dataSelect: _ctx.insurances,
                        class: "whitespace-no-wrap my-2 z-10"
                      }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "isDisabled", "disabledBackground", "dataSelect"])
                    ]),
                    _createVNode("div", _hoisted_15, [
                      (
                      _ctx.modelValue.isInsurance &&
                         (_ctx.modelValue.insurance === 'custom-rates' || _ctx.modelValue.insurance === 'custom')
                    )
                        ? (_openBlock(), _createBlock(_component_lp_input, {
                            key: 0,
                            modelValue: _ctx.modelValue.customRates,
                            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.modelValue.customRates = $event)),
                            error: _ctx.error.customRates,
                            onChange: _ctx.validateCustomRates,
                            errorCaption: _ctx.errorCaptionCustomRates,
                            placeholder: _ctx.$t('clientManagement.priceTypeForm.customRatesPlaceholder'),
                            min: "2",
                            max: "99",
                            suffix: "%",
                            isErrorIconInput: false,
                            type: "number",
                            isFloatingPrefixNumber: ""
                          }, null, 8, ["modelValue", "error", "onChange", "errorCaption", "placeholder"]))
                        : _createCommentVNode("", true)
                    ])
                  ])
                ]),
                _createVNode("div", _hoisted_16, [
                  _createVNode(_component_ToggleV2, {
                    customLabel: true,
                    onClick: _cache[9] || (_cache[9] = () => _ctx.toggleBasedDistrict()),
                    "model-value": _ctx.modelValue.retailBasedDistrict,
                    "style-active": _ctx.toggle - _ctx.active
                  }, {
                    "custom-label": _withCtx(() => [
                      _createVNode("p", _hoisted_17, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.rateBasedOnDistrict')), 1)
                    ]),
                    _: 1
                  }, 8, ["model-value", "style-active"]),
                  _createVNode("p", _hoisted_18, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.enableToAddDistrictsFromRetailCities')), 1)
                ])
              ], 64))
            : _createCommentVNode("", true)
        ]),
        (_ctx.modelValue.isCustomRate === 'khusus')
          ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('clientManagement.priceTypeForm.customPriceVersion'),
                class: "w-full mb-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    "model-value": 
                _ctx.isEdit
                  ? _ctx.modelValue.detailData.clientCurrentRate
                      .clientVersionCustomRate
                  : _ctx.modelValue.versionName
              ,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (
                _ctx.isEdit
                  ? (_ctx.modelValue.detailData.clientCurrentRate.clientVersionCustomRate = $event)
                  : (_ctx.modelValue.versionName = $event)
              )),
                    placeholder: _ctx.$t('clientManagement.priceTypeForm.enterPriceVersion'),
                    error: _ctx.isExist,
                    errorCaption: _ctx.$t('clientManagement.priceTypeForm.versionNameAlreadyExists'),
                    onChange: _cache[11] || (_cache[11] = () => _ctx.setIsExist(false)),
                    disabled: _ctx.isEdit
                  }, null, 8, ["model-value", "placeholder", "error", "errorCaption", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _createVNode("div", _hoisted_19, [
                _createVNode("div", _hoisted_20, [
                  _createVNode("div", _hoisted_21, [
                    _createVNode("p", _hoisted_22, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.price')), 1),
                    _createVNode("p", _hoisted_23, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.uploadDistrictCityByRouteRequest')), 1)
                  ]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('clientManagement.priceTypeForm.attachmentFile'),
                    class: "w-full",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UploadFile, {
                        "check-column": _ctx.columnToValidate,
                        maxRows: 160000,
                        type: "xlsx",
                        modelValue: _ctx.modelValue.archiveFile,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.modelValue.archiveFile = $event))
                      }, null, 8, ["check-column", "modelValue"]),
                      _createVNode("div", _hoisted_24, [
                        _createVNode("div", _hoisted_25, [
                          _hoisted_26,
                          _createVNode("p", _hoisted_27, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.templateFile')), 1)
                        ]),
                        _createVNode("div", {
                          class: "cursor-pointer",
                          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.download(_ctx.templateFileLink, _ctx.templateFileName)))
                        }, [
                          _hoisted_28
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode("div", null, [
                    _createVNode(_component_ToggleV2, {
                      customLabel: true,
                      onClick: _cache[14] || (_cache[14] = () => _ctx.toggleBasedDistrict()),
                      "model-value": _ctx.modelValue.retailBasedDistrict,
                      "style-active": _ctx.toggle - _ctx.active
                    }, {
                      "custom-label": _withCtx(() => [
                        _createVNode("p", _hoisted_29, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.rateBasedOnDistrict')), 1)
                      ]),
                      _: 1
                    }, 8, ["model-value", "style-active"]),
                    _createVNode("p", _hoisted_30, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.enableToAddDistrictsFromRetailCities')), 1)
                  ])
                ]),
                _createVNode("div", _hoisted_31, [
                  _createVNode("div", _hoisted_32, [
                    _createVNode(_component_Checkbox, {
                      id: "insurance",
                      modelValue: _ctx.modelValue.isInsurance,
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.modelValue.isInsurance = $event)),
                      binary: true
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_33, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.insurance')), 1)
                  ]),
                  _createVNode("p", _hoisted_34, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.insuranceHint')), 1),
                  _createVNode("div", _hoisted_35, [
                    _createVNode(_component_Select, {
                      onOpenSelect: _ctx.onOpenSelectInsurance,
                      onCloseSelect: _ctx.onCloseSelectInsurance,
                      isOpenMenu: _ctx.isOpenSelectInsurance,
                      value: _ctx.modelValue.insurance,
                      onChooseSelect: _ctx.onSelectInsurance,
                      isDisabled: !_ctx.modelValue.isInsurance,
                      disabledBackground: !_ctx.modelValue.isInsurance,
                      dataSelect: _ctx.insurances,
                      class: "whitespace-no-wrap my-2 z-10"
                    }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "isDisabled", "disabledBackground", "dataSelect"])
                  ]),
                  _createVNode("div", _hoisted_36, [
                    (
                    _ctx.modelValue.isInsurance &&
                      (_ctx.modelValue.insurance === 'custom-rates' || _ctx.modelValue.insurance === 'custom')
                  )
                      ? (_openBlock(), _createBlock(_component_lp_input, {
                          key: 0,
                          modelValue: _ctx.modelValue.customRates,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.modelValue.customRates = $event)),
                          error: _ctx.error.customRates,
                          onChange: _ctx.validateCustomRates,
                          errorCaption: _ctx.errorCaptionCustomRates,
                          placeholder: _ctx.$t('clientManagement.priceTypeForm.customRatesPlaceholder'),
                          min: "2",
                          max: "99",
                          suffix: "%",
                          isErrorIconInput: false,
                          type: "number",
                          isFloatingPrefixNumber: ""
                        }, null, 8, ["modelValue", "error", "onChange", "errorCaption", "placeholder"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ])
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.modelValue.isCustomRate === 'kombinasi')
          ? (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('clientManagement.priceTypeForm.customPriceVersion'),
                class: "w-full mb-5"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_lp_input, {
                    "model-value": 
                _ctx.isEdit
                  ? _ctx.modelValue.detailData.clientCurrentRate
                      .clientVersionCustomRate
                  : _ctx.modelValue.versionName
              ,
                    "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (
                _ctx.isEdit
                  ? (_ctx.modelValue.detailData.clientCurrentRate.clientVersionCustomRate = $event)
                  : (_ctx.modelValue.versionName = $event)
              )),
                    placeholder: _ctx.$t('clientManagement.priceTypeForm.enterCustomPriceVersionName'),
                    error: _ctx.isExist,
                    errorCaption: _ctx.$t('clientManagement.priceTypeForm.versionNameAlreadyExists'),
                    onChange: _cache[18] || (_cache[18] = () => _ctx.setIsExist(false)),
                    disabled: _ctx.isEdit
                  }, null, 8, ["model-value", "placeholder", "error", "errorCaption", "disabled"])
                ]),
                _: 1
              }, 8, ["label"]),
              _hoisted_37,
              _createVNode("div", _hoisted_38, [
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('clientManagement.priceTypeForm.normalPrice'),
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_SelectSearch, {
                      class: "mt-2",
                      onFilter: _ctx.fetchVersionRates,
                      isLoading: _ctx.loadingVersionRates,
                      options: _ctx.versionRates,
                      keyName: "rateVersionName",
                      keyValue: "rateVersionName",
                      placeholder: _ctx.$t('clientManagement.priceTypeForm.selectPriceVersion'),
                      modelValue: _ctx.modelValue.versionBasic,
                      "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.modelValue.versionBasic = $event)),
                      isDisabled: _ctx.isEdit,
                      disabledBackground: _ctx.isEdit
                    }, null, 8, ["onFilter", "isLoading", "options", "placeholder", "modelValue", "isDisabled", "disabledBackground"])
                  ]),
                  _: 1
                }, 8, ["label"]),
                _createVNode(_component_DataWrapper, {
                  label: _ctx.$t('clientManagement.priceTypeForm.origin3lc'),
                  class: "w-full"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_MultipleSelectSearch, {
                      "modal-title": _ctx.$t('clientManagement.priceTypeForm.selectedOrigin3lc'),
                      "option-name": "kota",
                      customDisplayAll: _ctx.$t('clientManagement.priceTypeForm.all3lc'),
                      onFocus: _ctx.fetchCity,
                      onFilter: _ctx.filterCity,
                      options: _ctx.cityOptions,
                      modelValue: _ctx.modelValue.originCities,
                      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.modelValue.originCities = $event)),
                      isDisabled: _ctx.isEdit,
                      keyName: "name",
                      keyValue: "value",
                      placeholder: _ctx.$t('clientManagement.priceTypeForm.select3lcByClientNeed'),
                      isLoading: _ctx.isLoadingCity,
                      showReset: "",
                      onChange: ($event: any) => (
                  {
                  }
                ),
                      class: "mt-2",
                      "able-to-delete-in-modal": ""
                    }, null, 8, ["modal-title", "customDisplayAll", "onFocus", "onFilter", "options", "modelValue", "isDisabled", "placeholder", "isLoading"])
                  ]),
                  _: 1
                }, 8, ["label"])
              ]),
              _createVNode(_component_ClientDiscountConfigToggle, {
                modelValue: _ctx.modelValue.useClientDiscountConfig,
                "onUpdate:modelValue": [
                  _cache[21] || (_cache[21] = ($event: any) => (_ctx.modelValue.useClientDiscountConfig = $event)),
                  _ctx.onUpdateClientDiscountConfigToggle
                ]
              }, null, 8, ["modelValue", "onUpdate:modelValue"]),
              (_ctx.modelValue.useClientDiscountConfig)
                ? (_openBlock(), _createBlock("div", _hoisted_39, [
                    _createVNode(_component_DataWrapper, {
                      label: "Diskon",
                      class: "w-full"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_DiscountProduct, {
                          error: _ctx.error,
                          modelValue: _ctx.modelValue.discount,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.modelValue.discount = $event))
                        }, null, 8, ["error", "modelValue"])
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode("div", _hoisted_40, [
                _createVNode("div", _hoisted_41, [
                  _createVNode("div", _hoisted_42, [
                    _createVNode("p", _hoisted_43, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.price')), 1),
                    _createVNode("p", _hoisted_44, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.uploadDistrictCityByRouteRequest')), 1)
                  ]),
                  _createVNode(_component_DataWrapper, {
                    label: _ctx.$t('clientManagement.priceTypeForm.attachmentFile'),
                    class: "w-full",
                    asterisk: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_UploadFile, {
                        "check-column": _ctx.columnToValidate,
                        maxRows: 160000,
                        type: "xlsx",
                        modelValue: _ctx.modelValue.archiveFile,
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.modelValue.archiveFile = $event))
                      }, null, 8, ["check-column", "modelValue"]),
                      _createVNode("div", _hoisted_45, [
                        _createVNode("div", _hoisted_46, [
                          _hoisted_47,
                          _createVNode("p", _hoisted_48, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.templateFile')), 1)
                        ]),
                        _createVNode("div", {
                          class: "cursor-pointer",
                          onClick: _cache[24] || (_cache[24] = ($event: any) => (_ctx.download(_ctx.templateFileLink, _ctx.templateFileName)))
                        }, [
                          _hoisted_49
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["label"])
                ]),
                _createVNode("div", _hoisted_50, [
                  _createVNode("div", _hoisted_51, [
                    _createVNode(_component_Checkbox, {
                      id: "insurance",
                      modelValue: _ctx.modelValue.isInsurance,
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.modelValue.isInsurance = $event)),
                      binary: true
                    }, null, 8, ["modelValue"]),
                    _createVNode("label", _hoisted_52, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.insurance')), 1)
                  ]),
                  _createVNode("p", _hoisted_53, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.insuranceHint')), 1),
                  _createVNode("div", _hoisted_54, [
                    _createVNode(_component_Select, {
                      onOpenSelect: _ctx.onOpenSelectInsurance,
                      onCloseSelect: _ctx.onCloseSelectInsurance,
                      isOpenMenu: _ctx.isOpenSelectInsurance,
                      value: _ctx.modelValue.insurance,
                      onChooseSelect: _ctx.onSelectInsurance,
                      isDisabled: !_ctx.modelValue.isInsurance,
                      disabledBackground: !_ctx.modelValue.isInsurance,
                      dataSelect: _ctx.insurances,
                      class: "whitespace-no-wrap my-2 z-10"
                    }, null, 8, ["onOpenSelect", "onCloseSelect", "isOpenMenu", "value", "onChooseSelect", "isDisabled", "disabledBackground", "dataSelect"])
                  ]),
                  _createVNode("div", _hoisted_55, [
                    (
                    _ctx.modelValue.isInsurance &&
                      ( _ctx.modelValue.insurance === 'custom-rates' || _ctx.modelValue.insurance === 'custom')
                  )
                      ? (_openBlock(), _createBlock(_component_lp_input, {
                          key: 0,
                          modelValue: _ctx.modelValue.customRates,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.modelValue.customRates = $event)),
                          error: _ctx.error.customRates,
                          onChange: _ctx.validateCustomRates,
                          errorCaption: _ctx.errorCaptionCustomRates,
                          placeholder: _ctx.$t('clientManagement.priceTypeForm.customRatesPlaceholder'),
                          min: "2",
                          max: "99",
                          suffix: "%",
                          isErrorIconInput: false,
                          type: "number",
                          isFloatingPrefixNumber: ""
                        }, null, 8, ["modelValue", "error", "onChange", "errorCaption", "placeholder"]))
                      : _createCommentVNode("", true)
                  ])
                ])
              ]),
              _createVNode("div", _hoisted_56, [
                _createVNode(_component_ToggleV2, {
                  customLabel: true,
                  onClick: _cache[27] || (_cache[27] = () => _ctx.toggleBasedDistrict()),
                  "model-value": _ctx.modelValue.retailBasedDistrict,
                  "style-active": _ctx.toggle - _ctx.active
                }, {
                  "custom-label": _withCtx(() => [
                    _createVNode("p", _hoisted_57, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.rateBasedOnDistrict')), 1)
                  ]),
                  _: 1
                }, 8, ["model-value", "style-active"]),
                _createVNode("p", _hoisted_58, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.enableToAddDistrictsFromRetailCities')), 1)
              ])
            ], 64))
          : _createCommentVNode("", true)
      ]),
      periode: _withCtx(() => [
        (_ctx.isEdit)
          ? (_openBlock(), _createBlock("div", _hoisted_59, [
              _createVNode(_component_DataWrapper, {
                label: _ctx.$t('clientManagement.priceTypeForm.updatePriceEffectiveOn'),
                class: "w-6/12"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_DateTimeInputField, {
                    class: "my-2",
                    modelValue: _ctx.modelValue.priceRateExpired,
                    dataTestid: "price-rate-expire-datetime",
                    title: _ctx.$t('clientManagement.priceTypeForm.priceChangeEffective'),
                    placeholder: _ctx.$t('clientManagement.priceTypeForm.selectDateTime'),
                    minDate: new Date(),
                    validateTodayMinHour: "",
                    "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.modelValue.priceRateExpired = $event))
                  }, null, 8, ["modelValue", "title", "placeholder", "minDate"])
                ]),
                _: 1
              }, 8, ["label"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", _hoisted_60, [
          _createVNode(_component_DataWrapper, {
            label: _ctx.isEdit ? 'Tanggal mulai' : 'Dimulai Dari',
            class: "w-6/12"
          }, {
            default: _withCtx(() => [
              (_ctx.isPeriodDateTimeEnabled)
                ? (_openBlock(), _createBlock(_component_DateTimeInputField, {
                    key: 0,
                    class: "my-2",
                    modelValue: _ctx.modelValue.priceRateStartDate,
                    dataTestid: "price-rate-start-datetime",
                    title: _ctx.$t('clientManagement.priceTypeForm.startDateTime'),
                    placeholder: _ctx.$t('clientManagement.priceTypeForm.selectStartDateTime'),
                    minDate: new Date(),
                    validateTodayMinHour: "",
                    disabled: _ctx.isEdit,
                    "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.modelValue.priceRateStartDate = $event))
                  }, null, 8, ["modelValue", "title", "placeholder", "minDate", "disabled"]))
                : (_openBlock(), _createBlock(_component_DatePicker, {
                    key: 1,
                    class: "my-2",
                    modelValue: _ctx.modelValue.priceRateStartDate,
                    "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.modelValue.priceRateStartDate = $event)),
                    minDate: new Date(new Date().setDate(new Date().getDate() + 1)),
                    disabled: _ctx.isEdit
                  }, null, 8, ["modelValue", "minDate", "disabled"])),
              _withDirectives(_createVNode("div", { class: "text-red-lp-100 text-12px xxl:text-14px" }, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.startDateCannotBeLaterOrEqualEndDate')), 513), [
                [_vShow, _ctx.validateStartEndDate]
              ])
            ]),
            _: 1
          }, 8, ["label"]),
          _createVNode(_component_DataWrapper, {
            label: _ctx.isEdit ? _ctx.$t('clientManagement.priceTypeForm.endDate') : _ctx.$t('clientManagement.priceTypeForm.until'),
            class: "w-6/12"
          }, {
            default: _withCtx(() => [
              (_ctx.isPeriodDateTimeEnabled)
                ? (_openBlock(), _createBlock(_component_DateTimeInputField, {
                    key: 0,
                    class: "my-2",
                    modelValue: _ctx.modelValue.priceRateEndDate,
                    dataTestid: "price-rate-end-datetime",
                    title: _ctx.$t('clientManagement.priceTypeForm.endDateTime'),
                    placeholder: _ctx.$t('clientManagement.priceTypeForm.selectEndDateTime'),
                    minDate: _ctx.modelValue.priceRateStartDate,
                    disabled: _ctx.isEdit,
                    "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.modelValue.priceRateEndDate = $event))
                  }, null, 8, ["modelValue", "title", "placeholder", "minDate", "disabled"]))
                : (_openBlock(), _createBlock(_component_DatePicker, {
                    key: 1,
                    class: "my-2",
                    modelValue: _ctx.modelValue.priceRateEndDate,
                    "onUpdate:modelValue": _cache[32] || (_cache[32] = ($event: any) => (_ctx.modelValue.priceRateEndDate = $event)),
                    minDate: _ctx.modelValue.priceRateStartDate,
                    disabled: _ctx.isEdit
                  }, null, 8, ["modelValue", "minDate", "disabled"])),
              _withDirectives(_createVNode("div", { class: "text-red-lp-100 text-12px xxl:text-14px" }, _toDisplayString(_ctx.$t('clientManagement.priceTypeForm.endDateCannotBeLessOrEqualStartDate')), 513), [
                [_vShow, _ctx.validateStartEndDate]
              ])
            ]),
            _: 1
          }, 8, ["label"])
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "options", "onOnResetForm", "onOnSelectOption"])
  ]))
}